import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CostPriceComponentPriceModel} from "web-shared";
import {CopyPasteService} from "web-shared";
import {CostPriceComponentService} from "../cost-price-component.service";
import {ManufacturingItemModel} from "web-shared";
import {ResourceModel} from "../../resources/models/resource.model";
import {SortEvent} from "primeng/api";
import {takeUntil} from "rxjs/operators";
import {BaseComponent, sortPrimeTableColumn} from "common-shared";

@Component({
  selector: 'mes-web-cost-price-components-edit-card',
  templateUrl: './cost-price-components-edit-card.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CostPriceComponentsEditCardComponent extends BaseComponent {
  @Input() container: ManufacturingItemModel | ResourceModel;
  @Input() readonly = false;
  @Input() cssClass = 'mb-2';
  @Output() changed = new EventEmitter<boolean>();
  selectedCpcs: CostPriceComponentPriceModel[] = [];

  constructor(public copyPasteService: CopyPasteService, public costPriceComponentService: CostPriceComponentService) {
    super();
  }

  add() {
    this.container.CostPriceComponentPrices = [...this.container.CostPriceComponentPrices, new CostPriceComponentPriceModel()];
    this.changed.emit();
  }

  remove(cpc: CostPriceComponentPriceModel) {
    this.container.CostPriceComponentPrices = [...this.container.CostPriceComponentPrices.filter(value => value !== cpc)];
    this.changed.emit();
  }

  removeSelected() {
    this.container.CostPriceComponentPrices = [...this.container.CostPriceComponentPrices.filter(cpc => !this.selectedCpcs.includes(cpc))];
    this.selectedCpcs = [];
    this.changed.emit();
  }

  paste(fromClipboard: boolean = false) {
    this.copyPasteService.paste('CostPriceComponentPrice', null, null, null, fromClipboard).then(result => {
      if (result?.type === 'CostPriceComponentPrice') {
        this.container.CostPriceComponentPrices = [...this.container.CostPriceComponentPrices, ...result.content as CostPriceComponentPriceModel[]];
        this.changed.emit();
      }
    });
  }

  setDateRange(dateRange: {From: Date, To: Date}, entity: CostPriceComponentPriceModel) {
    if (entity.FromDate !== dateRange?.From || entity.ToDate !== dateRange?.To) {
      this.changed.emit();
    }
    entity.FromDate = dateRange ? dateRange.From : null;
    entity.ToDate = dateRange ? dateRange.To : null;
  }

  customSort(event: SortEvent) {
    if (event.field === 'CostPriceComponentId') {
      this.costPriceComponentService.getAll$.pipe(takeUntil(this.componentDestroyed)).subscribe(cpcs => {
        if (cpcs?.length) {
          let helperColumn = 'CostPriceComponent';
          let hasNewLine = false;
          event.data.map(data => {
            if (!data[event.field]) {
              hasNewLine = true;
            }
            data[helperColumn] = cpcs.find(cpc => cpc.Id === data[event.field])?.DisplayName;
          });
          if (!hasNewLine) {
            event.field = helperColumn;
            sortPrimeTableColumn(event);
          }
        }
      });
    } else {
      sortPrimeTableColumn(event);
    }
  }
}
